import React from 'react';

const Ex1_Intro = () => {
    return (
        <div>Ex1_Intro Component</div>
    );
}

export default Ex1_Intro;
